/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ID } from '@gh/common-shared-data';

import { AbstractRestService, arrayOf, none, RestSettings, SlicedDataSource } from '@gh/core-data';
import { parametrizeUrl } from '@gh/core-util';

import { Observable } from 'rxjs';
import { MilestoneEventDetailsDto, MilestoneEventListItemDto } from './milestone-event.dto';

import { MilestoneEventDetailsMapper, MilestoneEventListItemMapper } from './milestone-event.mapper';

@Injectable()
export class MilestoneEventRestService extends AbstractRestService {
  constructor(private settings: RestSettings) {
    super(settings);
  }

  findAllAsDataSource(): SlicedDataSource<MilestoneEventListItemDto> {
    return this.createSlicedDataSourceGet(`${this.bp}/milestone-events`, arrayOf(MilestoneEventListItemMapper));
  }

  remove({ milestoneEventId, version }: MilestoneEventListItemDto): Observable<void> {
    return this.httpDelete(parametrizeUrl(`${this.bp}/milestone-events/${milestoneEventId}`, { version }), void 0, none());
  }

  get(milestoneEventId: ID): Observable<MilestoneEventDetailsDto> {
    return this.httpGet(`${this.bp}/milestone-events/${milestoneEventId}`, MilestoneEventDetailsMapper);
  }

  update(milestoneEvent: MilestoneEventDetailsDto): Observable<MilestoneEventDetailsDto> {
    return this.httpPut(
      `${this.bp}/milestone-events/${milestoneEvent.milestoneEventId}`,
      milestoneEvent,
      MilestoneEventDetailsMapper);
  }

  create(milestoneEvent: MilestoneEventDetailsDto): Observable<MilestoneEventDetailsDto> {
    return this.httpPost(`${this.bp}/milestone-events`, milestoneEvent, MilestoneEventDetailsMapper);
  }
}
